var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"margin":"0 16px 16px 16px","flex-flow":"row wrap"},attrs:{"type":"flex"}},[_c('el-button',{class:{ 'blue-button': _vm.buttonOutline === 'primary' },style:({
      fontFamily: _vm.fontSettings,
    }),attrs:{"size":"mini","target":"_blank","type":_vm.buttonOutline},on:{"click":_vm.openScribe}},[_vm._v(" Open Scribe ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }